export default "__VITE_ASSET__bEOtezsO__"